<template>
  <div id="pitaya">
    <detect-network v-on:detected-condition="connectionDetected" />
    <div v-if="connected || connectionOverridden">
      <localizer>
        <notifications group="pitaya" position="bottom right" />
        <vue-progress-bar></vue-progress-bar>
        <router-view></router-view>
      </localizer>
    </div>
    <div v-else>
      <offline
        :connectionOverride="connectionOverride"
        @connectionOverridden="connectionOverridden = true"
      />
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";

export default {
  name: "Pitaya",

  components: {
    Localizer: () => import("@/components/Localizer"),
    Offline: () => import("@/components/Offline"),
    DetectNetwork: () => import("v-offline"),
  },

  computed: {
    ...mapGetters(["showLoadingOverlay", "loadingMessage"]),
  },

  created() {
    // Initialize authentication state first
    this.$store.dispatch("initializeAuth");
    this.refreshAccessToken();
  },

  data() {
    return {
      connected: true, // Default to true to avoid flashing disconnected screen
      connectionOverride: false,
      connectionOverridden: false,
    };
  },

  mounted() {
    if (process.env.NODE_ENV === "development") {
      this.connectionOverride = true;
    }
  },

  methods: {
    connectionDetected(_isConnected) {
      this.$store
        .dispatch("setIsConnected", _isConnected)
        .then((isConnected) => {
          this.connected = process.env.ROOT_API.includes("localhost")
            ? "true"
            : isConnected;
        });
    },

    refreshAccessToken() {
      let isRedirecting = false; // Prevent multiple redirects

      axios.interceptors.response.use(
        (response) => {
          return response;
        },
        (error) => {
          const status = error.response?.status;

          if ((status === 401 || status === 403) && !isRedirecting) {
            // Only handle auth errors if we're not already on auth pages
            const currentPath = this.$router?.currentRoute?.path || "";
            const isOnAuthPage =
              currentPath.includes("/auth/") || currentPath.includes("/login");

            if (!isOnAuthPage) {
              isRedirecting = true;

              // Clear auth data immediately without API call
              this.$store.commit("logoutSuccess");

              // Use AuthUtils for proper redirect
              const AuthUtils = require("./utils/auth.utils").default;
              AuthUtils.clearAuthData();
              AuthUtils.redirectToLogin(currentPath);

              // Reset flag after redirect
              setTimeout(() => {
                isRedirecting = false;
              }, 1000);
            }
          }
          return Promise.reject(error);
        }
      );
    },
  },
};
</script>

<style>
#main {
  width: 100%;
  height: 100%;
}

*:focus {
  outline: none;
}

a {
  color: #fff;
}

a:hover {
  text-decoration: none;
  color: #fff;
}

::placeholder {
  color: #bbb !important;
}

a:focus {
  text-decoration: none !important;
  outline: none;
}

#pitaya {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.table-inactive {
  text-decoration: line-through;
}

.hidden {
  display: none;
}

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.form-control input {
  text-align: left;
}

.table-container {
  padding-top: 40px;
}

.analytics-tables {
  width: calc(100% - 30px);
  margin-left: auto;
  margin-right: auto;
}

.table-has-border {
  border: 1px solid #dee2e6;
}

.table-header {
  display: flex;
  justify-content: space-between;
}

.table-header-name {
  text-align: center;
  display: inline-block;
  width: 50%;
  margin-left: auto;
  margin-right: auto;
}

.table-header-daterange {
  display: inline-block;
  width: 15%;
  margin: 15px 20px;
}

.table-hover tr {
  cursor: pointer;
}

i.backup-icon:hover {
  color: #6378a5;
  background: white;
}

i.backup-icon {
  font-size: 12px;
  border: 1px solid white;
  padding: 2px;
}

.fixed-center {
  display: block;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}

.modal-content {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.fetching-spinner-content {
  background: transparent !important;
  border: none !important;
}

.loading-message {
  position: relative;
  top: -70px;
  color: #fcfcfc;
}

.pre-line {
  white-space: pre-line;
}
</style>
